export const orgLogoSrc = (url) => {
    return process.env.NODE_ENV === 'development'
        ? `${process.env.REACT_APP_LOGIN_LOGO_URL}/images/logo.png`
        : `${url.substring(0, url.indexOf('/login'))}/images/logo.png`;
};
